module.exports = __webpack_public_path__ + "rw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/rw.svg
// module id = 1041
// module chunks = 0